export default class HealthSituationDescription {
  description: string

  constructor(description?: string) {
    this.description = description ?? ''
  }

  isEmpty() {
    return !this.description
  }

  reset() {
    this.description = ''
  }
}
